"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Img = exports.ContainerLoading = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject, _templateObject2, _templateObject3;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: grid;\n  place-items: center;\n  width: ", ";\n  min-width: min-content;\n  overflow: hidden;\n  border-radius: ", ";\n"])), function (_ref) {
  var width = _ref.width;
  return width ? width : "min-content";
}, function (_ref2) {
  var borderType = _ref2.borderType;
  return (borderType === null || borderType === void 0 ? void 0 : borderType.toLowerCase()) === "rectangle" ? "6px" : (borderType === null || borderType === void 0 ? void 0 : borderType.toLowerCase()) === "circle" ? "50%" : "0px"; // default none
});

exports.Container = Container;

var ContainerLoading = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  display: grid;\n  place-items: center;\n  min-width: min-content;\n  font-size: ", "px;\n  color: ", ";\n  padding: 5px;\n"])), function (_ref3) {
  var sizeLoading = _ref3.sizeLoading;
  return sizeLoading ? sizeLoading : "30";
}, function (_ref4) {
  var colorLoading = _ref4.colorLoading;
  return colorLoading ? colorLoading : "#9e2674";
});

exports.ContainerLoading = ContainerLoading;

var Img = _styledComponents.default.img(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  display: ", ";\n  width: 100%;\n  object-fit: contain;\n  border-radius: inherit;\n"])), function (_ref5) {
  var show = _ref5.show;
  return show ? "grid" : "none";
});

exports.Img = Img;